import { apiGet } from './api';
import type { DictionaryLookupResult } from '../types/dictionary.types';

export const dictionaryService = {
  /**
   * Look up a word via the backend dictionary endpoint.
   *
   * The backend calls external APIs (Free Dictionary, MyMemory, Datamuse)
   * and returns a normalized result. No vocabulary record is created.
   *
   * @throws Error with a user-friendly message on failure.
   */
  async lookupWord(word: string): Promise<DictionaryLookupResult> {
    return apiGet<DictionaryLookupResult>('/dictionary/lookup', {
      word: word.trim(),
    });
  },
};
